'use strict'

const identity_ = require('lodash/identity')
const noop_ = require('lodash/noop')
const {
  DBSMViewer,
  UserErrors,
  WixData
} = require('dbsm-common/src/raven/apps')
const setupRaven = require('../raven/setupRaven')
const setupUserRaven = require('../raven/setupUserRaven')
const registerRavenToUnexpectedErrors = require('./registerRavenToUnexpectedErrors')
const errorBoundariesCreator = require('./error-boundaries/errorBoundaries')
const {
  errorBoundaryScopes: { USER_SCOPE, WIX_DATA_SCOPE, APPLICATION_SCOPE }
} = require('./error-boundaries/errorBoundaries')
const createRavenProxy = require('../raven/ravenProxy')

module.exports = ({
  global,
  appName,
  options,
  createClients,
  customReporter = noop_
}) => {
  const { Raven, UserRaven, WixDataRaven } = createClients()

  setupRaven(Raven, global, DBSMViewer.dsn, options, appName)
  registerRavenToUnexpectedErrors(Raven, global, appName)
  setupUserRaven(UserRaven, global, UserErrors.dsn, options, appName)
  setupRaven(WixDataRaven, global, WixData.dsn, options, appName)

  const ravenProxy = createRavenProxy(Raven)
  const userRavenProxy = createRavenProxy(UserRaven)
  const wixDataRavenProxy = createRavenProxy(WixDataRaven)

  const reportInfo = ravenInstance => (message, options) => {
    ravenInstance.captureMessage(
      message,
      Object.assign({ level: 'info' }, options)
    )
    customReporter('info', message)
  }

  const reportWarn = ravenInstance => (message, options) => {
    ravenInstance.captureMessage(
      message,
      Object.assign({ level: 'warning' }, options)
    )
    customReporter('warn', message)
  }

  const reportError = ravenInstance => (exception, options) => {
    ravenInstance.captureException(exception, options)
    customReporter('error', exception)
  }

  const errorBoundaries = errorBoundariesCreator({
    [USER_SCOPE]: (e, options) => reportError(userRavenProxy)(e, options),
    [WIX_DATA_SCOPE]: (e, options) =>
      reportError(wixDataRavenProxy)(e, options),
    [APPLICATION_SCOPE]: (e, options) => reportError(ravenProxy)(e, options)
  })

  const isErrorLevel = ravenData =>
    !ravenData.level || ravenData.level === 'error'

  return {
    addSessionData: cb => {
      const unsubscribeFns = [
        ravenProxy,
        userRavenProxy,
        wixDataRavenProxy
      ].map(proxy => proxy.addDataCallback(cb))

      return () => unsubscribeFns.forEach(fn => fn())
    },
    setUserContext: context => {
      ;[ravenProxy, userRavenProxy, wixDataRavenProxy].forEach(raven => {
        raven.setUserContext(context)
      })
    },
    breadcrumb: breadcrumb => ravenProxy.captureBreadcrumb(breadcrumb),
    info: reportInfo(ravenProxy),
    warn: reportWarn(ravenProxy),
    error: reportError(ravenProxy),
    applicationCodeZone: errorBoundaries.applicationCodeZone,
    userCodeZone: errorBoundaries.userCodeZone,
    wixDataCodeZone: errorBoundaries.wixDataCodeZone,
    onAppError: cb => {
      Raven.setDataCallback((data, originalCallback = identity_) => {
        const finalData = originalCallback(data)
        if (isErrorLevel(finalData)) {
          cb(finalData)
        }

        return finalData
      })
    }
  }
}



// WEBPACK FOOTER //
// ./logger/base.js